import React, { useMemo } from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import breadcrumbNameMap from "./constants";
import styles from "./AppBreadcrumbs.styled";

const AppBreadcrumbs: React.FC = () => {
  const location = useLocation();

  const pathNames = useMemo(
    () => location.pathname.split("/").filter((path) => path),
    [location.pathname],
  );

  const homeBreadcrumb = useMemo(() => {
    return pathNames.length ? (
      <Link component={RouterLink} to="/" sx={styles.breadcrumbLink}>
        Головна
      </Link>
    ) : (
      <Typography sx={styles.breadcrumbActive}>Головна</Typography>
    );
  }, [pathNames.length]);

  const breadcrumbs = useMemo(() => {
    return pathNames.map((value, index) => {
      const to = `/${pathNames.slice(0, index + 1).join("/")}`;
      const isLast = index === pathNames.length - 1;
      const breadcrumbName = breadcrumbNameMap[to];

      return isLast ? (
        <Typography key={to} sx={styles.breadcrumbActive}>
          {breadcrumbName}
        </Typography>
      ) : (
        <Link
          component={RouterLink}
          to={to}
          key={to}
          sx={styles.breadcrumbLink}
        >
          {breadcrumbName}
        </Link>
      );
    });
  }, [pathNames, breadcrumbNameMap]);

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={styles.breadcrumbs}>
      {homeBreadcrumb}
      {breadcrumbs}
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
